import React, { useEffect, useState } from 'react';
import { NavBarTypes } from '../../../sections/sitewide/components/NavBar/navBarTypes';
import { desktopscreensize } from '../../../utilities/constants';
import { Link } from 'gatsby';
import { Navbar } from '@codeparva/ui-components-library';
import { weakKey } from '../../../utilities/weakKey';
import { TickMarkHelper } from './TickMark';
import { useVariant } from '../../../sections/sitewide/components/NavBar/hooks/NavBarContext';
import { useThemeContext } from '../../../sections/sitewide/components/Footer/hooks/themeContext';
import { handleReRoutingAndDropDownState } from './utilities/NavBarClickHandler';
import { getClassesForNavBarLinks } from './utilities/NavLinkColorPicker';

export const LinkTouchDeviceHandler = ({
  locationDetails,
  linkTo,
  NavLinkText,
  navLinkDropDown,
}: NavBarTypes.TLinkTouchTypes) => {
  const currentDetails = useVariant();
  const currTheme = useThemeContext();
  const [NavBarLinkColor, setNavBarLinkColor] = useState('dark');
  const [NavBarTextColor, setNavBarTextColor] = useState('black');
  useEffect(() => {
    const { NavBarLinkColor, NavBarTextColor } = getClassesForNavBarLinks(
      currTheme
    );
    setNavBarLinkColor(NavBarLinkColor);
    setNavBarTextColor(NavBarTextColor);
  }, []);
  const isPaddingLess = () => {
    return currentDetails.widthwindow < desktopscreensize
      ? 'is-paddingless'
      : '';
  };

  const getClassNameForNavBarLink = () => {
    return `navBarLink ${isPaddingLess()} has-text-${NavBarTextColor} cp-link-${NavBarLinkColor}`;
  };

  return (
    <Link
      to={
        locationDetails && locationDetails.length > 1
          ? '/select-location-page'
          : linkTo
      }
      state={{
        from: NavLinkText.toLowerCase().replace(/\s/g, ''),
      }}
    >
      <Navbar.Link
        arrowless={currentDetails.widthwindow < desktopscreensize}
        renderAs="div"
        key={weakKey(navLinkDropDown)}
        className={getClassNameForNavBarLink()}
        onClick={(e: any) => handleReRoutingAndDropDownState(e, currentDetails)}
      >
        {NavLinkText}
        <TickMarkHelper
          currentDetails={currentDetails}
          NavLinkText={NavLinkText}
        />
      </Navbar.Link>
    </Link>
  );
};
